<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tbdFHi/tc-custom/9781250070135.jpg?1720011210384" alt="This image is the cover for the book O's Little Guide to the Big Questions, O's Little Guide"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">O's Little Guide to the Big Questions, O's Little Guide
      </h1>
      <p class="bookDescription body article font2">
        <b>Engage with life’s deepest mysteries with thoughtful and provocative personal essays from Thich Nhat Hanh, Rita Wilson, Gloria Steinem, and others.</b><br/><br/><i>What truly matters?</i><br/><br/><i>What is my purpose?</i><br/><br/><i>When is the right time to make a change?</i><br/><br/><i>Who is most important to me?</i><br/><br/>Award-winning and bestselling writers for <i>O, The Oprah Magazine</i> have been tackling these and other crucial questions since the magazine’s inception. Here, they share their eye-opening, soul-expanding insights. Among the many jewels in the collection, Terry Tempest Williams describes the utter shock of opening her late mother’s journals—and the lessons she gleaned from what she found inside; Thich Nhat Hanh finds compassion in the midst of anger; Julie Orringer reveals how we can know when we’ve found “the one.”<br/><br/>Offering valuable perspective to anyone feeling lost or in need of a reset, <i>O’s Little Guide to the Big Questions</i> is proof that while the search for meaning can be daunting, it’s also clarifying, motivating, empowering, and the surest path to becoming the person you were meant to be.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        The Editors of O, The Oprah Magazine
      </h2>
      
      <p class="authorDescription body article">Each month <I>O, The Oprah Magazine</I> helps readers live their best lives, serving up information and inspiration on everything from lasting love to luscious food. With a signature blend of candor and humor, fresh advice and timeless wisdom, the magazine offers people the tools they need to, as Oprah Winfrey says, "become more of who they are"-to love themselves more deeply, to look hopefully toward the future, and to leap wholeheartedly into the adventure of being alive.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Flatiron Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4db72c88